import * as React from 'react';

const Caret = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={32} height={32} stroke="currentColor" strokeWidth={4} aria-hidden="true" viewBox="0 0 32 32" {...props}>
        <path fill="none" d="M28 12 16.707 23.293a1 1 0 0 1-1.414 0L4 12" />
    </svg>
);
export default Caret;
